import { BeeFieldState } from '../BeeField.types';

export const getFieldOpacity = (state?: BeeFieldState): number => {
  return state === BeeFieldState.DISABLED ? 0.5 : 1;
};
